import colors from 'vuetify/util/colors'

export default {
  dark: false,
  colors: {
    background: '#F5F5F5',
    // surface: '#FF0000',

    red: '#DE3730',
    'red-lighten-1': '#FFEDEA',
    'red-darken-1': '#93000A',
    error: '#DE3730', // '#E65100',

    blue: '#2196F3',
    'blue-lighten-1': '#D3EAFD',
    'blue-darken-1': '#077BD8',
    'blue-accent-1': '#176FC7',
    'blue-accent-2': '#63ADED',
    info: '#2196F3', //'#178DA0',

    green: '#54AF4C',
    'green-lighten-1': '#E4F4D8',
    'green-darken-1': '#1C7F20',
    success: '#54AF4C',

    // orange: '#FDB022',
    // 'orange-lighten-1': '#FEF8EC',
    // 'orange-darken-1': '#F88C00',
    warning: '#FDB022', // '#F08712',

    // unusualify colors
    // accent: '#8c9eff',

    //vuetify colors
    primary: '#dd60B4',            // R:39  G:160 B:180
    'primary-lighten-1': '#4DBBC6', // R:77  G:187 B:198
    'primary-lighten-2': '#74CED7', // R:116 G:206 B:215
    'primary-lighten-3': '#AFE2E7', // R:175 G:226 B:231
    'primary-lighten-4': '#F5FAFC', // R:245 G:250 B:252
    'primary-darken-1': '#00758D',  // R:0   G:117 B:141
    'primary-darken-2': '#00566A',  // R:0   G:86  B:106
    'primary-darken-3': '#01404F',  // R:1   G:64  B:79
    'primary-accent': '#DEF5FA',    // R:222 G:245 B:250

    'on-primary': '#FFFFFF',
    // 'on-primary-lighten-1': '#FFFFFF', // R:77  G:187 B:198
    // 'on-primary-lighten-2': '#FFFFFF', // R:116 G:206 B:215
    // 'on-primary-lighten-3': '#000000', // R:175 G:226 B:231
    // 'on-primary-lighten-4': '#000000', // R:245 G:250 B:252
    // 'on-primary-darken-1': '#FFFFFF',  // R:0   G:117 B:141
    // 'on-primary-darken-2': '#FFFFFF',  // R:0   G:86  B:106
    // 'on-primary-darken-3': '#FFFFFF',  // R:1   G:64  B:79
    // 'on-primary-accent': '#FFFFFF',    // R:222 G:245 B:250

    // Secondary Colors
    secondary: '#E16437',           // R:225 G:100 B:55
    'secondary-lighten-1': '#EC9F83', // R:236 G:159 B:131
    'secondary-lighten-2': '#F2BAA6', // R:242 G:186 B:166
    'secondary-lighten-3': '#F7D6CA', // R:247 G:214 B:202
    'secondary-lighten-4': '#FCF1ED', // R:252 G:241 B:237
    'secondary-lighten-5': '#F7D6CA', // R:247 G:214 B:202
    'secondary-lighten-6': '#F2BAA6', // R:242 G:186 B:166
    'secondary-darken-1': '#D55020',  // R:213 G:80  B:32
    'secondary-darken-2': '#C3491D',  // R:195 G:73  B:29
    'secondary-darken-3': '#B1431B',  // R:177 G:67  B:27
    'secondary-darken-4': '#A03C18',  // R:160 G:60  B:24
    'secondary-darken-5': '#8E3515',  // R:142 G:53  B:21
    'secondary-darken-6': '#7C2F13',  // R:124 G:47  B:19

    'on-secondary': '#FFFFFF',
    'on-secondary-lighten-1': '#FFFFFF',
    'on-secondary-lighten-2': '#FFFFFF',
    'on-secondary-darken-1': '#FFFFFF',
    'on-secondary-darken-2': '#FFFFFF',
    'on-secondary-darken-3': '#FFFFFF',
    'on-secondary-darken-4': '#FFFFFF',
    'on-secondary-darken-5': '#FFFFFF',

    grey: '#768184',                // R:118 G:129 B:132
    'grey-lighten-1': '#879092',    // R:135 G:144 B:146
    'grey-lighten-2': '#999FA1',    // R:153 G:159 B:161
    'grey-lighten-3': '#AAEAEF',    // R:170 G:234 B:239
    'grey-lighten-6': '#F2F1F1',    // R:242 G:241 B:241
    'grey-lighten-4': '#CACBCB',    // R:202 G:203 B:203
    'grey-lighten-5': '#E4E4E4',    // R:228 G:228 B:228
    'grey-lighten-6': '#F2F1F1',    // R:242 G:241 B:241
    'grey-darken-1': '#657275',     // R:101 G:114 B:117
    'grey-darken-2': '#546367',     // R:84  G:99  B:103
    'grey-darken-3': '#435458',     // R:67  G:84  B:88
    'grey-darken-4': '#32454A',     // R:50  G:69  B:74
    'grey-darken-5': '#20363B',     // R:32  G:54  B:59

    // grey accents
    'grey-accent-1': '#EEF1F2',     // R:238 G:241 B:242
    'grey-accent-2': '#DEE3E5',     // R:222 G:227 B:229
    'grey-accent-3': '#BFC8CB',     // R:191 G:200 B:203
    'grey-accent-4': '#8CA0A7',     // R:140 G:160 B:167
    'grey-accent-5': '#6F797B',     // R:111 G:121 B:123
    'grey-accent-6': '#3F484A',     // R:63  G:72  B:74
    'grey-accent-7': '#171D1E',     // R:23  G:29  B:30


    'on-green-lighten-1': '#FFFFFF',
    'on-green-lighten-2': '#FFFFFF',
    'on-green-lighten-3': '#FFFFFF',
    'on-green-lighten-4': '#FFFFFF',
    'on-green-lighten-5': '#FFFFFF',
    'on-green-lighten-6': '#FFFFFF',

    // surface: '#FFFFFF',
    // 'surface-bright': '#FFFFFF',
    // 'surface-light': '#EEEEEE',
    // 'surface-variant': '#424242',
    // 'on-surface-variant': '#EEEEEE',

    // secondary: '#F08712',
    // 'secondary-darken-1': '#018786',


    // // State colors
    // info: '#2196F3',
    // 'on-info': '#077BD8',
    // 'info-container': '#D3EAFD',

    // error: '#DE3730',
    // 'on-error': '#93000A',
    // 'error-container': '#FFEDEA',

    // success: '#54AF4C',
    // 'on-success': '#1C7F20',
    // 'success-container': '#E4F4D8',

    // warning: '#FDB022',
    // 'on-warning': '#F8BC00',
    // 'warning-container': '#F8BC00',

    // // Surface variants
    // surface: '#171D1E',
    // 'surface-variant': '#424545',
    // 'surface-container': '#8DCDA7',
    // 'surface-container-low': '#B8CBD8',
    // 'surface-container-high': '#E8F3F5',
  },
  variables: {
    'border-color': '#000000',
    'border-opacity': 0.12,
    'high-emphasis-opacity': 0.87,
    'medium-emphasis-opacity': 0.60,
    'disabled-opacity': 0.38,
    'idle-opacity': 0.04,
    'hover-opacity': 0.04,
    'focus-opacity': 0.12,
    'selected-opacity': 0.08,
    'activated-opacity': 0.12,
    'pressed-opacity': 0.12,
    'dragged-opacity': 0.08,
    'theme-kbd': '#212529',
    'theme-on-kbd': '#FFFFFF',
    'theme-code': '#F5F5F5',
    'theme-on-code': '#000000',
  }
}
